import { useIsMutating } from "@tanstack/react-query";
import { useResourceFormConfig } from "src/components/Form/hooks/useResourceForm/useResourceFormConfig.ts";
import type { FormAction } from "src/components/Form/Form.types.ts";
import { useParams } from "react-router-dom";

export const useIsAdditionalFormMutationRunning = ({
  resource,
  action,
  tab,
}: {
  resource: string;
  action: FormAction;
  tab?: string;
}) => {
  const params = useParams();
  const {
    formConfig: { additionalMutation },
  } = useResourceFormConfig({
    resource,
    action,
    tab,
  });

  const count = useIsMutating(
    typeof additionalMutation === "function"
      ? additionalMutation({ params })
      : additionalMutation,
  );

  return count > 0;
};
